import { isNotNullUndefinedBlank, isValidJSON } from "../helpers/common";

// const storagePrefix = 'trade_strategy_';
const storagePrefix = 'radar_';

const storage = {
    getToken: () => {
        return (isValidJSON(window.localStorage.getItem(`${storagePrefix}token`))) ? JSON.parse(window.localStorage.getItem(`${storagePrefix}token`)) : "";
    },
    setToken: (token) => {
        window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
    },
    clearToken: () => {
        window.localStorage.removeItem(`${storagePrefix}token`);
    },
    getRefreshToken: () => {
        return (isValidJSON(window.localStorage.getItem(`${storagePrefix}refreshToken`))) ? JSON.parse(window.localStorage.getItem(`${storagePrefix}refreshToken`)) : "";
    },
    setRefreshToken: (token) => {
        window.localStorage.setItem(`${storagePrefix}refreshToken`, JSON.stringify(token));
    },
    clearRefreshToken: () => {
        window.localStorage.removeItem(`${storagePrefix}refreshToken`);
    },
    isAuthorized: () => {
        const token = storage.getToken();
        return !!token;
    },
    // Retrieves and parses a value from localStorage based on the given dynamic propertyName key.
    getLocalProperty: (propertyName) => {
        return ((propertyName || "") !== "") ? JSON.parse(window.localStorage.getItem(`${storagePrefix}${propertyName}`)) : "";
    },
    // Stores a value (e.g., boolean, number, or object) under a dynamic propertyName key in localStorage.
    setLocalProperty: (propertyName, value) => {
        window.localStorage.setItem(`${storagePrefix}${propertyName}`, JSON.stringify(value));
    },
    // Removes a specific propertyName key and its value from localStorage.
    clearLocalProperty: (propertyName) => {
        window.localStorage.removeItem(`${storagePrefix}${propertyName}`);
    },
    // Adds or updates a property in a JSON object stored under a dynamic propertyName key and variableName in localStorage.
    setDynamicDataJSON: (propertyName, variableName, value) => {
        localStorage.setItem(`${storagePrefix}${propertyName}`, JSON.stringify(
            {
                ...(JSON.parse(localStorage.getItem(`${storagePrefix}${propertyName}`)) || {}),
                [variableName]: value
            }));
    },
    // Retrieves a specific property from a JSON object stored under a dynamic propertyName key and variableName in localStorage.
    getDynamicDataJSON: (propertyName, variableName) => {
        return JSON.parse(localStorage.getItem(`${storagePrefix}${propertyName}`))?.[variableName] || ''
    },
    // Clears a specific variableName based on propertyName key from a JSON object in localStorage or removes the entire object if isAllClear is true.
    clearDynamicDataJSON: (propertyName, variableName, isAllClear = false) => {
        if (isAllClear) {
            localStorage.removeItem(`${storagePrefix}${propertyName}`);
        } else {
            localStorage.setItem(`${storagePrefix}${propertyName}`, JSON.stringify({
                ...JSON.parse(localStorage.getItem(`${storagePrefix}${propertyName}`)) || {},
                ...(variableName ? { [variableName]: undefined } : {})
            }))
        }
    },
    // Clears specified properties from multiple JSON objects stored in localStorage.
    clearMultipleDynamicData: (propertyName, variables) => {
        Array.from(variables).forEach((variable) => {
            storage.clearDynamicDataJSON(propertyName, variable);
        });
    },
    //This function is used to check whether a specific localStorage property exists or not.
    isPropertyExists: (propertyName) => {
        return isNotNullUndefinedBlank(localStorage.getItem(`${storagePrefix}${propertyName}`));
    },
};

export {
    storage
};